import { UseLoadingReturn } from "@/hooks/use-loading";
import useUpdate from "@/hooks/use-update";
import { IWorkflowStepInput } from "@/interfaces/workflow-step.interface";
import workflowStepService from "@/services/workflow-steps";
import { UpdateByIdProps } from "@/types/requests.types";

export type UpdateWorkflowStepProps = UpdateByIdProps<IWorkflowStepInput>;

export type UseUpdateWorkflowStepReturn = {
  update: (props: UpdateWorkflowStepProps) => Promise<void>;
} & UseLoadingReturn;

const useUpdateWorkflowStep = (): UseUpdateWorkflowStepReturn => {
  const { isLoading, startLoading, endLoading, loadingIcon, update } =
    useUpdate<IWorkflowStepInput>({
      operation: (formData, workflowStepId) => workflowStepService.update(formData, workflowStepId),
    });

  return {
    isLoading,
    startLoading,
    endLoading,
    loadingIcon,
    update,
  };
};

export default useUpdateWorkflowStep;
